import { FetchAllLicenses } from '@account-users/account/state/licenses/licenses.actions';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Account, SectionDomain, SectionDomainSetting } from '../../models';
import {
  accountDomainSettingActions,
  sectionDomainActions,
} from '../../store/actions/domain-settings-edit.actions';
import { getAccountSettingActions } from '../../store/actions/domain-settings.actions';
import {
  getSelectedAccountDomainName,
  getSelectedAccountId,
  getSelectedAccountToggle,
  getSelectedSectionsDomains,
  State,
} from '../../store/reducers';
import { PrivateDomainPresenter } from '../private-domain-presenter/private-domain.presenter';

@Component({
  providers: [PrivateDomainPresenter],
  selector: 'apsis-back-office-private-domain-edit',
  templateUrl: './private-domain-edit.component.html',
  styleUrls: ['./private-domain-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateDomainEditComponent implements OnInit {
  public accounts$: Observable<Account[]>;
  public selectedAccount$: Observable<string>;
  public selectedAccountToggle$: Observable<boolean>;
  public selectedAccountDomainName$: Observable<string>;
  public accountsControl: FormControl;
  public sections$: Observable<SectionDomain[]>;
  public selectedSectionsDomains$: Observable<SectionDomainSetting[]>;
  public enableSave$: Observable<boolean>;

  public selected: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly store: Store<State>,
    private readonly privateDomainPresenter: PrivateDomainPresenter,
  ) {
    this.accountsControl = new FormControl();
  }

  ngOnInit(): void {
    const accountId = this.route.snapshot.params.accountId;

    this.store.dispatch(new FetchAllLicenses({ accountId }));

    this.store.dispatch(accountDomainSettingActions.clear());

    this.selectedAccount$ = this.store.pipe(select(getSelectedAccountId));
    this.selectedAccountToggle$ = this.store.pipe(
      select(getSelectedAccountToggle),
    );
    this.selectedAccountDomainName$ = this.store.pipe(
      select(getSelectedAccountDomainName),
    );

    this.sections$ = this.privateDomainPresenter.getSections();
    this.selectedSectionsDomains$ = this.store.pipe(
      select(getSelectedSectionsDomains),
    );

    this.enableSave$ = this.privateDomainPresenter.enableSave();
    this.store.dispatch(getAccountSettingActions.get({ accountId }));
  }

  selectAccountDomainName(accountDomainName: string) {
    this.store.dispatch(
      accountDomainSettingActions.setAccountDomainName({ accountDomainName }),
    );
  }

  toggleDomain(enabled: boolean) {
    this.store.dispatch(accountDomainSettingActions.toggleDomain({ enabled }));
  }

  addSectionDomain(sectionDomain: SectionDomainSetting) {
    this.store.dispatch(
      sectionDomainActions.addSectionDomain({ section: sectionDomain }),
    );
  }

  removeSectionDomain(sectionId: string) {
    this.store.dispatch(
      sectionDomainActions.removeSectionDomain({ sectionId }),
    );
  }

  selectSectionDomain(sectionId: string) {
    this.store.dispatch(
      sectionDomainActions.selectSectionDomain({ sectionId }),
    );
  }

  cancel() {
    this.router.navigate(['/private-domain']);
    this.store.dispatch(accountDomainSettingActions.clear());
  }

  update() {
    this.store.dispatch(accountDomainSettingActions.update());
  }
}
